import { _getTextWidth } from '@dynatrace/strato-components/typography';

import {
  CONTEXT_VALUES_FONT,
  CONTEXT_VALUES_INDICATOR_LABEL_SPACE,
} from '../constants.js';

export const getContextValueWidth = (formattedValue: string) => {
  const { Family: fontFamily, Size: fontSize } = CONTEXT_VALUES_FONT;

  const stringWidth = _getTextWidth(formattedValue, { fontFamily, fontSize });

  return stringWidth + CONTEXT_VALUES_INDICATOR_LABEL_SPACE;
};
